import Embed from './embed';

class LiveEmbed extends Embed {
  static create(value) {
    const domNode = super.create({
      ...value,
      label: 'live',
      customTitle: value.title,
      iconName: 'forum',
      iconClass: '',
      buttons: ['edit'],
    });

    domNode.insertAdjacentHTML('beforeend', this.html(value));

    return domNode;
  }

  static value(domNode) {
    const { embedId, embedTitle } = domNode.dataset;
    return {
      id: embedId,
      title: embedTitle,
    };
  }

  static html() {
    return '';
  }
}

LiveEmbed.blotName = 'liveEmbed';
LiveEmbed.className = 'ql-live';
LiveEmbed.tagName = 'div';

export default LiveEmbed;
